import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { Dots } from '@ynap/animations';
import Button from '../Button/Button';

const bem = new BEMHelper('SimpleAsyncButton');

class SimpleAsyncButton extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { className, containerClass, type, loading, copy, disabled, nohover, ...rest } = this.props;

        const buttonModifier = [className, 'primaryButton', loading && 'animating', disabled && 'disabled', nohover && 'nohover'];
        const buttonContent = loading ? <Dots type={type} /> : copy;

        return (
            <div className={bem('asyncButtonWrapper', null, containerClass)}>
                <Button className={bem(null, null, buttonModifier)} type={type} disabled={disabled} {...rest}>
                    {buttonContent}
                </Button>
            </div>
        );
    }
}

SimpleAsyncButton.propTypes = {
    className: PropTypes.string,
    containerClass: PropTypes.string,
    loading: PropTypes.string.isRequired,
    copy: PropTypes.string,
    type: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

SimpleAsyncButton.defaultProps = {};

export default SimpleAsyncButton;
